import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CssBaseline, Container } from '@mui/material';
import { useThemeContext } from '../../contexts/ThemeContext';

const AuthLayout: React.FC = () => {
  const { currentTheme } = useThemeContext();

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          backgroundImage: `linear-gradient(135deg, ${currentTheme.palette.primary.main}15, ${currentTheme.palette.secondary.main}15)`,
        }}
      >
        <Container maxWidth="sm">
          <Outlet />
        </Container>
      </Box>
    </>
  );
};

export default AuthLayout;

